/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { TOP_CATEGORY_CARD_NAMES } from '@/wabunka-src/constants/topCategoryCardName';

/**
 * 発火タイミング：Topページのカテゴリカードがクリックされた時
 */
export const sendGAWabunkaClickTopCategoryCardEvent = (categoryName: (typeof TOP_CATEGORY_CARD_NAMES)[keyof typeof TOP_CATEGORY_CARD_NAMES]) => {
  sendWabunkaGAEvent(`click_top_category_card_${categoryName}`, {});
};
